// extracted by mini-css-extract-plugin
export default {"MinimizeButton":"PanelMinimizeButton_MinimizeButton__8GGNE"};